import Vue from 'vue'
import MessageComponent from './index.vue'

const Message = {}
let messageNode = null

Message.install = function (Vue) {
  const MessageConstructor = Vue.extend(MessageComponent)
  if (messageNode) return;
  messageNode = new MessageConstructor()
  messageNode.$mount()
  document.body.appendChild(messageNode.$el)

  Vue.prototype.$message = function (msg, closable) {
    messageNode.content = msg
    messageNode.visible = true
    messageNode.closable = closable
  }
}

export default Message




// WEBPACK FOOTER //
// ./src/components/common-components/features/message/index.js